import { InjectionToken } from '@angular/core';

/** One format a document may be read as: the value the viewer routes on, and the text that names it. */
export interface DocumentOpenFormat {
  format: string;
  label: string;
}

/**
 * What a document may be opened as, filled in by the application that ships a viewer. Asked for rather
 * than imported: an import of the viewer would compile it into every application this library is part
 * of, documents or no documents. An application that provides nothing offers no choice of format.
 */
export const DOCUMENT_OPEN_FORMATS = new InjectionToken<ReadonlyArray<DocumentOpenFormat>>('DOCUMENT_OPEN_FORMATS', {
  factory: () => []
});
